/**
 * CAL FIRE Fire Hazard Severity Zone tier palette. Shared between the web
 * overlay renderer (useFhszOverlay.web.ts) and MapLegend so the fills on the
 * map and the swatches in the key can never drift apart. Also mirrored (as
 * plain hex) in scripts/export-fhsz-geojson.ts's own comments — that script
 * only ever writes FHSZ_Description, never a color, so it has no live import
 * of this file to keep in sync.
 */
export type FhszTier = 'Moderate' | 'High' | 'Very High';

export const FHSZ_TIER_COLORS: Record<FhszTier, { fill: string; stroke: string }> = {
  Moderate: { fill: '#F6D860', stroke: '#C9A93B' },
  High: { fill: '#F49E4C', stroke: '#C67B2E' },
  'Very High': { fill: '#E4572E', stroke: '#B03A1C' },
};

export const FHSZ_TIER_ORDER: FhszTier[] = ['Moderate', 'High', 'Very High'];

/** Source line shown in the key and in the map layers sheet. */
export const FHSZ_SOURCE_LABEL = 'Fire Hazard Severity Zones, CAL FIRE 2024-25';
